<template>
  <nav>
    <form @submit.prevent="submitForm">
      <div class="form-control" :class="{ invalid: isEmailValid === false }">
        <div class="content">
          <p>{{$t('emailRegisteration.title')}}</p>
          <input
            type="email"
            id="email"
            name="email"
            :placeholder="[[$t('emailRegisteration.emailAddress')]]"
            @blur="validateEmail"
            v-model.trim="email"
          />
          <div class="ErrorMessage">
            <p1 v-if="isEmailValid === false">{{$t('emailRegisteration.invalidEmail')}}</p1>
          </div>

          <br />
          <base-button @click="navigateNextPage">{{$t('proceed')}}</base-button>
        </div>
      </div>
    </form>
  </nav>
  <div class="pagenumber">
    <label>1/7</label>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: '',
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      isEmailValid: true,
    };
  },

  methods: {
    validateEmail() {
      if (this.email !== '' && this.reg.test(this.email))
        this.isEmailValid = true;
      else this.isEmailValid = false;
    },

    navigateNextPage() {
      this.validateEmail();
      console.log('Is email valid:' + this.isEmailValid);
      if (this.isEmailValid) {
        this.$store.state.email = this.email;
        this.$router.push('/interestedlanguages');
      }
    },
  },
};
</script>

<style scoped>
.form-control.invalid input {
  border-color: rgb(121, 11, 11);
}

input {
  background-color: #eaf8f8;
  border: 5px solid #c4c4c4;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgb(255, 255, 255);
  padding: 1rem 3rem;
  margin: 3rem auto;
  background-color: #eaf8f8;
  font-size: 35px;
  width: 1000px;
}
</style>
